import { HttpClient } from '@angular/common/http';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { Intercom } from 'ng-intercom-x';
import { AuthService } from './auth.service';
import { IntercomUser } from '../models/intercom-user.model';
import { environment } from 'src/environments/environment';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
    providedIn: 'root'
})
export class IntercomService {
    constructor(
        private intercom: Intercom,
        private http: HttpClient,
        private authService: AuthService,
        @Inject(PLATFORM_ID) private platformId: object
    ) {
        if (isPlatformBrowser(this.platformId)) {
            this.authService.authStatusObs.subscribe(status => {
                // delete the local data of intercom and restart only if it's not the webview from the app
                if (!status) {
                    this.shutDownChat();
                }
                this.updateUserHashForChat();
            });
        }
    }

    initializeChat(user?) {
        if (isPlatformBrowser(this.platformId)) {
            this.intercom.boot({
                // app region
                api_base: 'https://api-iam.eu.intercom.io',
                app_id: environment.INTERCOM_APP_ID,
                // Supports all optional configuration.
                widget: {
                    activator: '#intercom'
                },
                ...user
            });
        }
    }

    updateIntercomConfig(config: any) {
        this.intercom.update(config);
    }

    shutDownChat() {
        this.intercom.shutdown();
    }

    updateUserHashForChat() {
        if (this.authService._getDefaultAuthStatus()) {
            this.http
                .post<IntercomUser>(environment.IXFI_API + 'v1/users/get-intercom-id', {
                    device_type: 'web'
                })
                .subscribe(res => {
                    if (res.status == 200) {
                        this.initializeChat({
                            user_id: res.data.intercomId,
                            user_hash: res.data.intercomHash
                        });
                    }
                });
        } else {
            this.initializeChat();
        }
    }
}
